module.exports = __webpack_public_path__ + "img/title.23752c0c.png";